module.exports = __webpack_public_path__ + "img/骑单车.02eb799e.png";